import { DosageCalculator, CalculatorRegistry } from "./types";
import { PeriodDelayCalculator } from "../dosage-calculators/PeriodDelayCalculator";
import { WeightLossCalculator } from "../dosage-calculators/WeightLossCalculator";
import { TravelHealthCalculator } from "../dosage-calculators/TravelHealthCalculator";
import { NEWS2Calculator } from "@/components/clinical-risk-calculators/NEWS2Calculator";

// Registry of all dosage calculators
export const calculatorRegistry: CalculatorRegistry = {
  travelHealth: {
    id: "travelHealth",
    name: "Travel Health Calculator",
    description: "Complete travel health planning: vaccinations and malaria prevention in one place",
    consultationTypes: [
      "travel",
      "travel health",
      "Travel Health Consultation",
      "travel consultation",
    ],
    component: TravelHealthCalculator,
  },
  periodDelay: {
    id: "periodDelay",
    name: "Period Delay Calculator",
    description: "Determine suitable medication for menstrual cycle delay",
    consultationTypes: [
      "period delay",
      "period_delay",
      "Period Delay",
      "Period Delay Consultation",
      "menstrual",
      "menstrual delay",
    ],
    component: PeriodDelayCalculator,
  },
  weightLoss: {
    id: "weightLoss",
    name: "Weight Loss Medication Calculator",
    description: "Calculate appropriate dosage for weight loss medication based on initial injection",
    consultationTypes: [
      "weight loss",
      "weight_loss",
      "Weight Loss",
      "Weight Loss Consultation",
      "obesity",
      "weight management",
      "semaglutide",
      "wegovy",
      "saxenda",
      "mounjaro",
    ],
    component: WeightLossCalculator,
  },
  news2: {
    id: "news2",
    name: "NEWS2 Calculator",
    description: "National Early Warning Score 2 — assess clinical deterioration risk",
    consultationTypes: [],
    component: NEWS2Calculator,
  },
};

/**
 * Get calculators available for a specific consultation type
 */
export function getCalculatorsForConsultationType(
  consultationType?: string
): DosageCalculator[] {
  if (!consultationType) {
    return [];
  }

  const normalizedType = consultationType.toLowerCase().trim();
  
  return Object.values(calculatorRegistry).filter((calculator) =>
    calculator.consultationTypes.some((type) =>
      type.toLowerCase().includes(normalizedType) || 
      normalizedType.includes(type.toLowerCase())
    )
  );
}

/**
 * Get a specific calculator by ID
 */
export function getCalculatorById(id: string): DosageCalculator | undefined {
  return calculatorRegistry[id];
}

/**
 * Check if any calculators are available for a consultation type
 */
export function hasCalculatorsForConsultationType(
  consultationType?: string
): boolean {
  return getCalculatorsForConsultationType(consultationType).length > 0;
}
